var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lms__superadmin_workspaces_edit_feedbackforms_table"},[_c('component-table',{attrs:{"labels":[
            {
                key: 'name',
                title: 'Feedback form name',
                type: 'string',
                sortable: true,
                queryable: true
            },
            {
                key: 'updatedAt',
                title: 'Last edited',
                type: 'string'
            },
            {
                key: 'status',
                title: 'Status',
                type: 'string'
            },
            {
                key: 'actions',
                title: '',
                type: 'string'
            }
        ],"items":_vm.items,"component-table-item":_vm.LmsSuperadminWorkspaceEditFeedbackFormsTableItem,"sort-queryable":_vm.sortQueryable},on:{"emit-edit":function($event){return _vm.handlePerformEmit({ message: 'emit-edit', value: arguments[0] })},"emit-make-copy":function($event){return _vm.handlePerformEmit({ message: 'emit-make-copy', value: arguments[0] })},"emit-make-default":function($event){return _vm.handlePerformEmit({ message: 'emit-make-default', value: arguments[0] })},"emit-remove":function($event){return _vm.handlePerformEmit({ message: 'emit-remove', value: arguments[0] })},"emit-empty-state-submit":function($event){return _vm.handlePerformEmit({ message: 'emit-empty-state-submit' })},"emit-sort":_vm.handleSort,"emit-perform-get-items":_vm.emitPerformGetItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }